<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
    <div class="max-w-lg w-full">
      <div class="bg-white rounded-lg shadow-lg text-center py-8 px-6">
        <img :src="imgSrc" width="120" class="mx-auto py-3 px-3 object-contain" alt="Access Denied" />
        <div class="text-3xl font-bold text-gray-800 mt-2">
          S<span class="text-red-600">top</span> It!
        </div>

        <div class="mt-3 text-xl font-semibold text-gray-800">
          FORBIDDEN ACCESS
        </div>

        <div class="text-sm text-gray-600 mt-3 leading-relaxed">
          You do not have the permission to view this resource.
        </div>
        <div class="text-sm text-gray-600 mt-2">
          Kindly
          <a @click.prevent="doLogout" href="#" class="no-underline font-semibold text-primary-600 hover:text-primary-700">click here</a>
          to login again.
        </div>
        <div class="mt-6">
          <button
            class="btn-sm-primary px-4 py-2 text-sm font-medium rounded-md"
            @click="goToHome"
          >
            Go to Dashboard Page
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router"
import imgSrc from "@/assets/img.png"
import { touchSession } from "@/composables/tokenRefresh"

const router = useRouter()

const doLogout = () => {
  sessionStorage.clear()
  touchSession()
  router.push({ name: "login" })
}

const goToHome = () => {
  router.push({ name: "Home" })
}
</script>

